import useIsInappWebview from "./useIsInappWebview";
import { isDev } from "config";

export default function useIsSecuritySettingsAvailable() {
  const isInappWebview = useIsInappWebview();
  return isDev || isInappWebview;
}
